<template>
  <div v-if="examine && examine.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showExamine && $permission.permissionAllow('Examines', 'examine')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              detailMode
              ? $emit('edit')
              : $router.push('/examines/' + examine.id + '/edit');"
          >
            {{ $t("Examine.actions.examine") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.examine") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Examines', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="
              detailMode
              ? $emit('view')
              : $router.push('/examines/' + examine.id);
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Examine.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showReturn && $permission.permissionAllow('StockOutOrders', 'add')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="$router.push('/stock-out-orders/new?examine_code=' + examine.examine_code);"
          >
            <v-icon x-small class="pe-1">fa-truck-loading</v-icon>
            {{ $t("Examine.actions.return") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.return") }}</span>
      </v-tooltip>
      <!-- TODO：缺接口 -->
      <v-tooltip top v-if="showExport">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Examine.actions.examine_detail_export") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.examine_detail_export") }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "ExamineActions",

  props: {
    examine: Object,
    detailMode: Boolean,
    showView: Boolean,
    showExamine: Boolean,
    showAbnormal: Boolean,
    showExport: Boolean,
    showReturn: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    editLogisticAlert: false,
  }),
};
</script>